import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { SessionService } from 'src/app/shared/services/session.service';
import { getIsConnectionStarted, getIsReConnected, getLobbyLocationSelected } from 'src/app/state';
import { StatusBarData } from './shared/models/status-bar-data';
import { getLobbyStatusData, State } from './state';
import * as StatusBarPageActions from './state/actions/lobby-status-bar-page.actions';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';

@Component({
  selector: 'app-lobby-status-bar',
  templateUrl: './lobby-status-bar.component.html',
  styleUrls: ['./lobby-status-bar.component.scss']
})
export class LobbyStatusBarComponent implements OnInit, OnDestroy {

  private userSignInLocationId: number = 0;
  private userSignInTenantId: number = 0;
  statusBarData: StatusBarData = <StatusBarData>{};
  public locationName:string = '';
  statusBarSubscriptions = new Subscription();

  constructor(private store: Store<State>, private session: SessionService, private translationLoaderFacade: TranslationLoaderFacade) { }

  @Input() set locationId(value: number) {
    if (this.userSignInLocationId !== value && this.userSignInTenantId !== undefined && this.userSignInTenantId !== 0) {
      this.store.dispatch(StatusBarPageActions.subscribeToStatusBarData({tenantId: this.userSignInTenantId, locationId: value}));
    }
    this.userSignInLocationId = value;
  }

  get locationId(): number {
    return this.userSignInLocationId;
  }

  @Input() set tenantId(value: number) {
    if (this.userSignInTenantId !== value && this.userSignInLocationId !== undefined && this.userSignInLocationId !== 0) {
      this.store.dispatch(StatusBarPageActions.subscribeToStatusBarData({tenantId: value, locationId: this.locationId}));
    }
    this.userSignInTenantId = value;
  }

  get tenantId(): number {
    return this.userSignInTenantId;
  }

  ngOnInit() {
    const signalRConnectionSubscription = this.store.select(getIsConnectionStarted).subscribe(isHubConnected => {
      if (isHubConnected) {
        console.log('lobby received hub connected');

        if (this.userSignInLocationId !== undefined && this.userSignInLocationId !== 0 && this.userSignInTenantId !== undefined && this.userSignInTenantId !== 0) {
      
            this.store.dispatch(StatusBarPageActions.subscribeToStatusBarData({tenantId: this.tenantId, locationId: this.locationId}));
          
        }
      }
    });

    const signalRConnectionResumeSubscription = this.store.select(getIsReConnected).subscribe(isHubConnected => {
      if (isHubConnected) {   

        if (this.userSignInLocationId !== undefined && this.userSignInLocationId !== 0 && this.userSignInTenantId !== undefined && this.userSignInTenantId !== 0) {
            this.store.dispatch(StatusBarPageActions.subscribeToStatusBarData({tenantId: this.tenantId, locationId: this.locationId}));
        }
      }
    });

    const locationSubscription = this.store.select(getLobbyLocationSelected).subscribe((location) => { 
      this.locationName=location.locationName;      
    });
       
    const statBarSubscription = this.store.select(getLobbyStatusData).subscribe((statusBarData) => { 
      if (statusBarData) {
        this.statusBarData = statusBarData;
      }
      else {
        this.statusBarData = {
          visitorsWaiting: 0,
          avgWaitTime: 0,
          visitorServed: 0,
          staffSignedIn: 0,
          hourlyWaitCounts: []
        }
      }
    });

    this.statusBarSubscriptions.add(locationSubscription);
    this.statusBarSubscriptions.add(signalRConnectionSubscription);
    this.statusBarSubscriptions.add(statBarSubscription);
    this.statusBarSubscriptions.add(signalRConnectionResumeSubscription);
  }

  ngOnDestroy(): void {
    this.statusBarSubscriptions.unsubscribe();
  }
}
